/*eslint-disable*/
import React, { useState, useEffect, useContext } from "react";
import { Grid, Paper, Typography } from "@material-ui/core";
import DashboardListingDisplayCard from "components/DashboardListingsDisplayCard";
import { Button } from "@material-ui/core";
import { useDispatch, useSelector } from "react-redux";
import CircularLoading from "../../components/CircularLoading";
import { FirebaseContext } from "common";
import { useLocation, useNavigate } from "react-router-dom";
import moment from "moment";
import GridItem from "components/Grid/GridItem.js";
import GridContainer from "components/Grid/GridContainer.js";
import { STYLES } from "config";
import {
    Row,
    Col,
    CardBody,
    Card,
    CardHeader,
    CardFooter,
    CardTitle,
    Container,
    FormText,
    Input,
    ModalFooter,
} from "reactstrap";

import CustomDropDownPicker from "../../components/CustomDropDownPicker";
import CreateListingsDashboardModal from "components/CreateListingDashboardModal";
import CreateEnquiryDashboardModal from "components/CreateEnquiryDashboardModal";
import CreateAreaDashboardModal from "components/CreateAreaDashboardModal";

const RegionInfo = () => {
    const [currentBranch, setCurrentBranch] = useState({});

    const usersdata = useSelector((state) => state.usersdata);
    const auth = useSelector((state) => state.auth);
    const areaData = useSelector((state) => state.areaData);

    const { api } = useContext(FirebaseContext);
    const {
        removeBrokerFromArea,
        updateRegionAreas,
        removeAreaFromRegion,
    } = api;

    const navigate = useNavigate();
    const location = useLocation();
    let branch = auth.info.profile.adminHomeOffice
        ? auth.info.profile.adminHomeOffice
        : auth.info.profile.brokerHomeOffice;
    const dispatch = useDispatch();

    const brokers = useSelector((state) => state.brokers.users);
    const areas = useSelector((state) => state.areaData.areas);
    const listings = useSelector((state) => state.ListingData.listingsByBranch);
    const branchManagementReducer = useSelector((state) => state.branchData);
    const activeListingsByBranch = useSelector(
        (state) => state.ListingData.activeListingsByBranch
    );
    const inactiveListingsByBranch = useSelector(
        (state) => state.ListingData.inactiveListingsByBranch
    );
    const enquiryManagementReducer = useSelector((state) => state.enquirydata);
    const branchEnquiries = useSelector(
        (state) => state.enquirydata.branchEnquirries
    );
    const activeBranchEnquiries = useSelector(
        (state) => state.enquirydata.activeBranchEnquiries
    );
    const inactiveBranchEnquiries = useSelector(
        (state) => state.enquirydata.inactiveBranchEnquiries
    );

    const region = location.state;
    const [brokerList, setBrokerList] = useState([]);
    const [areaList, setAreaList] = useState([]);
    const [allBrokersList, setAllBrokersList] = useState([]);
    const [allAreasList, setAllAreasList] = useState([]);
    const [adminList, setAdminList] = useState([]);
    const [state, setState] = useState({
        regionId: region.regionId,
        regionName: region.regionName,
        shareBrokers: [],
        areas: [],
    });

    const EditRegion = () => {
        //Inriching Enquiry Data before sending it to the action
        // !DO NOT CHANGE WITHOUT PERMISSION FROM GAYNOR OR STEVEN!!!
        // ?last updated 25/04/2025
        let regionData = {
            regionId: state.regionId,
            //selectedBranch: state.selectedBranch,
            regionName: state.regionName,
            shareBrokers: state.shareBrokers,
            areas: state.areas,
        };
        console.log("regionData", regionData);

        handleSubmit(regionData);
    }

    const removeArea = (area) => {
        const userConfirmed = window.confirm(
            `Are you sure you want to remove the area from "${region.regionName}"?`
        );

        if (userConfirmed) {
            try {
                console.log("area data:", area);

                dispatch(removeAreaFromRegion(area, region));
                alert("Broker removed Successfully");
            } catch (error) {
                console.error("Failed to remove broker:", error);
                alert("Something went wrong while removing the broker.");
            }
        } else {
            console.log("Area removal cancelled by user.");
        }
    }

    const handleSubmit = async (regionData) => {
        if (
            state.regionId &&
            state.areas.length > 0
        ) {
            try {
                await dispatch(updateRegionAreas(regionData));
                alert("Area added Successfully");
            } catch (error) {
                console.error("Failed to add area:", error);
                alert("Something went wrong while adding the area.");
            }
        } else {
            alert(`No region ID or areas provided!`);
        }
    };

    useEffect(() => {
        let arr = [];

        if (areas) {
            for (let index = 0; index < areas.length; index++) {
                const element = areas[index];

                // Populate the list with all areas

                arr.push({
                    value: element.areaId, // The area ID
                    label: `${element.areaName}`, // area name
                });

            }
            setAllAreasList(arr.sort((a, b) => a.label.localeCompare(b.label)));
            console.log("All Areas List:", arr); // Log area list to verify population
        }
    }, [areas]);

    //   useEffect(() => {
    //     let arr = [];
    //     let arr2 = [];

    //     if (brokers) {
    //       for (let index = 0; index < brokers.length; index++) {
    //         const element = brokers[index];

    //         // Populate the list with all brokers

    //         arr.push({
    //           value: element.id, // The broker ID (or name if preferred)
    //           label: `${element.firstName} ${element.lastName}`, // Broker name
    //         });

    //       }
    //       setAllBrokersList(arr.sort((a, b) => a.label.localeCompare(b.label)));
    //       console.log("All Brokers List:", arr); // Log broker list to verify population
    //     }
    //   }, [brokers]);

    //   useEffect(() => { //checks which brokers have this region in their broker Object
    //     let arr = [];
    //     if (brokers) {
    //       for (let index = 0; index < brokers.length; index++) {
    //         const element = brokers[index];

    //         //brokers regions
    //         const brokerRegions = element?.Regions;

    //         if (brokerRegions) {  //Checking if broker has the matching location or the areaId of the area object
    //           const hasValue = 
    //           //Object.values(brokerAreas || {}).includes(area.Location) ||
    //           Object.keys(brokerRegions || {}).includes(region?.regionId);

    //           if (hasValue) {
    //             arr.push(element);
    //           }

    //         }
    //       }

    //       setBrokerList(
    //         arr.sort((a, b) => a?.username?.localeCompare(b?.username))
    //       );
    //     }
    //   }, [brokers]);

    useEffect(() => { //checks which areas have this region in their area Object
        let arr = [];
        if (areas) {
            for (let index = 0; index < areas.length; index++) {
                const element = areas[index];

                //areas
                const areaRegion = element?.Regions;

                if (areaRegion) {  //Checking if the area has the regionId of the current region
                    const hasValue =
                        Object.keys(areaRegion || {}).includes(region?.regionId);

                    if (hasValue) {
                        arr.push(element);
                    }

                }
            }

            setAreaList(
                arr.sort((a, b) => a?.areaName?.localeCompare(b?.areaName))
            );
        }
    }, [areas]);

    // useEffect(() => {
    //     if (areas && region?.areas) {
    //         const areaIds = Array.isArray(region.areas)
    //             ? region.areas
    //             : Object.values(region.areas);
    //         const filtered = areas.filter(a => areaIds.includes(a?.areaId));
    //         const sorted = filtered.sort((a, b) =>
    //             a?.areaName?.localeCompare(b?.areaName)
    //         );
    //         setAreaList(sorted);
    //     }
    // }, [areas, region]);

    useEffect(() => {
        console.log("Area List:", areaList);
    }, [areaList]);

    useEffect(() => {
        if (region.areas > 0) {
            console.log("region List:", region.areas.length);
        }
    }, [region.areas]);

    const saveData = (location, data) => {
        setState({
            ...state,
            [location]: data,
        });
    };

    return usersdata.loading ? (
        <CircularLoading />
    ) : (
        <div>
            <Grid container direction="row" spacing={2}>
                <Grid item xs>
                    <Card
                        style={{
                            backgroundColor: STYLES.PRIMARY_APP_CLR,
                            width: "100%",
                            height: "20%",
                        }}
                    >
                        <CardHeader>
                            <CardTitle tag="h4" style={{ color: "white" }}>
                                Region Information
                            </CardTitle>
                        </CardHeader>
                        <CardBody>
                            <Container>
                                <>
                                    <Row>
                                        <Col md="12">
                                            <Card
                                                style={{
                                                    minWidth: "275px",
                                                    border: "none",
                                                    boxShadow: "0 4px 20px rgba(0, 0, 0, 0.1)",
                                                }}
                                            >
                                                <CardHeader
                                                    style={{
                                                        backgroundColor: "#f8f9fa",
                                                        borderBottom: STYLES.PRIMARY_APP_CLR,
                                                    }}
                                                >
                                                    <CardTitle
                                                        tag="h4"
                                                        style={{ color: STYLES.TERTIARY_APP_CLR, fontWeight: "bold" }}
                                                    >
                                                        {currentBranch.BranchName} Region Details
                                                    </CardTitle>
                                                </CardHeader>
                                                <CardBody style={{ padding: "20px" }}>
                                                    <Row>
                                                        <Col md="6">
                                                            <p style={{ fontWeight: "600" }}>
                                                                <strong>Region Name:</strong>{" "}
                                                                {region.regionName ? region.regionName : ""}
                                                            </p>
                                                        </Col>
                                                        <Col md="6">
                                                            <p style={{ fontWeight: "600" }}>
                                                                <strong>Branch:</strong>{" "}
                                                                {region.selectedBranchName ? region.selectedBranchName : ""}
                                                            </p>
                                                        </Col>
                                                    </Row>
                                                </CardBody>
                                            </Card>
                                        </Col>
                                    </Row>
                                </>

                            </Container>
                        </CardBody>
                    </Card>
                </Grid>
            </Grid>

            <Row>
                <GridItem xs={12} sm={12} md={12} lg={12}>
                    <GridContainer spacing={1}>

                        <GridItem xs={6}>
                            {/*Area List Card */}
                            <Card
                                style={{
                                    backgroundColor: "#399ddb",
                                    width: "95%",
                                    height: "100%",
                                    justifyContent: "center"
                                }}
                            >
                                <CardHeader>
                                    <CardTitle tag="h4" style={{ color: "white" }}>
                                        ADD AREAS
                                    </CardTitle>
                                </CardHeader>
                                <CardBody>
                                    <GridItem xs={12} sm={12} md={12} lg={12}>
                                        <GridContainer spacing={1}>
                                            <GridItem xs={12}>
                                                <FormText color="white" tag="span">
                                                    Areas:
                                                </FormText>

                                                {allAreasList && allAreasList.length > 0 ? (
                                                    <CustomDropDownPicker
                                                        options={allAreasList}
                                                        isMulti={true}
                                                        value={state.areas}
                                                        onChange={(selectedArea) => {
                                                            saveData("areas", selectedArea)
                                                        }}
                                                    />
                                                ) : (
                                                    <FormText color="grey">No areas available</FormText> // Fallback if no brokers
                                                )}
                                            </GridItem>
                                        </GridContainer>
                                    </GridItem>
                                </CardBody>
                                <ModalFooter>
                                    <Button
                                        style={{
                                            backgroundColor: "GRAY",
                                            height: 45,
                                            marginRight: 10,
                                            color: "white",
                                        }}
                                        onClick={
                                            EditRegion
                                        }
                                    >Add Areas</Button>
                                </ModalFooter>
                            </Card>
                        </GridItem>

                        <GridItem xs={6}>
                            {/*Broker List Card */}
                            <DashboardListingDisplayCard title="AREAS">
                                <Row mb="12">
                                    <Col md="12">
                                        <span style={{ fontSize: 18, margin: 5 }}>
                                            Total Region Areas:
                                        </span>{" "}
                                        {areaList.length}
                                    </Col>
                                    <hr />
                                    {areaList.map((area) => {
                                        return (
                                            <>
                                                <div
                                                    style={{
                                                        display: "flex",
                                                        flexDirection: "row",
                                                        justifyContent: "space-evenly",
                                                        alignItems: "center",
                                                        margin: 5,
                                                    }}
                                                >
                                                    <div>
                                                        {" "}
                                                        <span style={{ fontSize: 18, color: "black" }}>
                                                            {" "}
                                                            {`${area.areaName}`}{" "}
                                                        </span>
                                                    </div>

                                                    <div>
                                                        <Button
                                                            color="primary"
                                                            onClick={() => {
                                                                if (
                                                                    auth.info.profile.adminHomeOffice === branch
                                                                ) {
                                                                    removeArea(area);
                                                                } else {
                                                                    alert(
                                                                        "You do not have permission to perform this action"
                                                                    );
                                                                }
                                                            }}
                                                        >
                                                            Remove
                                                        </Button>
                                                    </div>
                                                </div>
                                                <hr />
                                            </>
                                        );
                                    })}

                                    {/* Add more statistics as needed */}
                                </Row>
                            </DashboardListingDisplayCard>
                        </GridItem>

                    </GridContainer>
                </GridItem>
            </Row>
        </div>
    );
};


export default RegionInfo
